module.exports = __webpack_public_path__ + "img/inactivebasic.f575644c.svg";